//爱博医疗
import Overview from './overview.vue';
import Full from './full.vue';
import MobOverview from './mob-overview.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 